import { all, call, delay, spawn } from 'redux-saga/effects';
import ordersSaga from './orders/saga';
import userSaga from './sagas';

function* runResiliently(saga, name) {
    while (true) {
        try {
            yield call(saga);
            return;
        } catch (error) {
            console.error(`${name} stopped unexpectedly and will restart.`, error);
            yield delay(1000);
        }
    }
}

export default function* rootSaga() {
    yield all([
        spawn(runResiliently, ordersSaga, 'Order service'),
        spawn(runResiliently, userSaga, 'Restaurant service')
    ]);
}
